import { createAsyncThunk } from '@reduxjs/toolkit'
import GameLog from './game-log-model'
import { delete_gameLog, load_gameLogs, store_gameLog } from './gameLog-service'

export const LoadGameLogsAsync = createAsyncThunk<any, any>(
  'composer/load/gameLog',
  async (params: { uid: string }) => {
    return await load_gameLogs(params)
  },
)

export const CreateGameLogAsync = createAsyncThunk<any, any>(
  'composer/create/gameLog',
  async (params: GameLog) => {
    return await store_gameLog(params)
  },
)

export const DeleteGameLogAsync = createAsyncThunk<any, any>(
  'composer/delete/gameLog',
  async (params) => {
    return await delete_gameLog(params)
  },
)
